import type { iCustomerInvoice } from "@sdk/bookings/booking-model";
import { iStore } from "../../store.model";
import { CreateSelectorForEntities } from "../../utils/entity-slice-creator";

export const {
  selectQueryMap: selectCustomerInvoiceQueryMap,
  selectEntityMap: selectCustomerInvoicesMap,
  selectQueryMapAll: selectCustomerInvoicesMapAll,
  selectQueryAllList: selectCustomerInvoicesAllList,
  selectAllEntities: selectAllCustomerInvoices,
  selectAllEntitiesQuery: selectAllCustomerInvoicesQuery,
  selectEntityById: selectCustomerInvoiceById,
  selectEntityQuery: selectCustomerInvoiceQuery,
  selectEntityQueryList: selectCustomerInvoiceQueryList,
} = CreateSelectorForEntities<iStore, iCustomerInvoice>({
  sliceName: "customerInvoices",
});
